var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToothMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#00a0df;}.cls-3{clip-path:url(#clip-path);}.cls-4{fill:#fffef8;}.cls-5{fill:#f2efda;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M470.12,147.94C450,109.3,403.58,98.2,398.19,97.07c-39.75-8.29-45.21,13.67-96.61,14.28-54,.64-60.47-23.41-102.77-14.28-6,1.3-52,12.61-71.93,50.87-26.47,50.83,29.24,76.48,38.93,191,1.54,18.19,3.75,60.35,19.46,113.47,7.87,26.59,17.39,50.09,33.85,52.44,11,1.56,20.83-6.92,23.7-9.39,42.82-36.95-5-123.77,33-147.92,7.91-5,19.24-6,22.67-6.21,3.43.19,14.76,1.19,22.67,6.21,38,24.15-9.81,111,33,147.92,2.87,2.47,12.7,10.95,23.7,9.39,16.46-2.35,26-25.85,33.85-52.44,15.71-53.12,17.92-95.28,19.46-113.47C440.88,224.42,496.59,198.77,470.12,147.94Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_211",
    "data-name": "Layer 211"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 300,
    cy: 301,
    r: 300
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M470.12,147.94C450,109.3,403.58,98.2,398.19,97.07c-39.75-8.29-45.21,13.67-96.61,14.28-54,.64-60.47-23.41-102.77-14.28-6,1.3-52,12.61-71.93,50.87-26.47,50.83,29.24,76.48,38.93,191,1.54,18.19,3.75,60.35,19.46,113.47,7.87,26.59,17.39,50.09,33.85,52.44,11,1.56,20.83-6.92,23.7-9.39,42.82-36.95-5-123.77,33-147.92,7.91-5,19.24-6,22.67-6.21,3.43.19,14.76,1.19,22.67,6.21,38,24.15-9.81,111,33,147.92,2.87,2.47,12.7,10.95,23.7,9.39,16.46-2.35,26-25.85,33.85-52.44,15.71-53.12,17.92-95.28,19.46-113.47C440.88,224.42,496.59,198.77,470.12,147.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M218.25,94.25c0,.06-27.41,5.53-46.25,27.75-14,16.55-20.27,38.63-19.76,60.1.56,23.92,11.22,45.3,20.71,66.72,9.82,22.15,13.56,46.11,15.58,70.11,2.68,31.71,3.86,63.51,9.62,94.89C202.63,438.23,209.8,474.44,236,485c17.84,7.19,27.68-6.64,48.81,3.3,17.94,8.44,17.62,21.7,36.61,37.94,26.79,22.91,56.9,22.47,56.58,24.63-.54,3.63-115.48,24.13-201-37.28C56.37,427,47.41,215.79,127.73,135.52,161.55,101.72,218.21,94.17,218.25,94.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M294,345c10.32-10.51,32.24-3.14,42.68,3.17,24.13,14.58,18.35,38.37,17.81,61.92-.62,27,5.94,100.55,50.51,80.91,13.69-6,17.5-20.67,19-20,1.78.79-.83,22.41-16.43,38.79-3.09,3.24-20,21-37.19,18.32-18.57-2.89-23.34-27.48-52.56-101.66C295.35,369.4,286,353.11,294,345Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M246.06,119.32c2.15-3.43,21.86,13.61,54.94,14.68,35,1.13,56.95-16.5,58.94-13,2.37,4.2-25.34,36.19-59.83,34.63C267.55,154.16,243.49,123.41,246.06,119.32Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToothMarker);
export default __webpack_public_path__ + "static/media/tooth_marker.1c8319bef3f773d14d2940e8666171d0.svg";
export { ForwardRef as ReactComponent };